// extracted by mini-css-extract-plugin
export default {"Toolbar":"ProsjektRedigerContainer-module__Toolbar__zPoQj","Buttons":"ProsjektRedigerContainer-module__Buttons__CXyiv"};